import type { ColDef, ICellRendererParams, IRowNode } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { ITodolistTemplate } from '~/types/todolist-template'

import ActionMenu from '~/components/ActionMenu'
import { CreatedByCellRenderer } from '~/components/CellRenderers/CreatedByCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { dateComparator } from '~/utils/date'
import { actionsColDef, createdByColDef, lastUpdateColDefV2, textColDef } from '~/utils/table'

export interface IContext {
  handleRedirect: (path: string) => void
}

const ActionsCellRenderer = ({
  context,
  data,
}: ICellRendererParams<ITodolistTemplate, unknown, IContext>): ReactElement => {
  if (data) {
    const { handleRedirect } = context

    const menu: Menu = {
      navigations: [
        {
          action: () => handleRedirect(`/todolist-templates/${data.template.template_id}`),
          label: 'Display template',
          type: 'internal',
        },
      ],
    }

    return <ActionMenu menu={menu} placement="top" />
  }

  return <div />
}

const columns: ColDef[] = [
  textColDef(TextCellRenderer, {
    field: 'template.title',
    headerName: 'Title',
  }),
  textColDef(TextCellRenderer, {
    field: 'template.description',
    headerName: 'Description',
  }),
  createdByColDef(CreatedByCellRenderer, {
    field: 'template.created_by',
    suppressHeaderMenuButton: true,
    valueGetter: ({ data }) => data?.template || undefined,
  }),
  lastUpdateColDefV2({
    comparator: (
      _: unknown,
      __: unknown,
      { data: firstItem }: IRowNode<ITodolistTemplate>,
      { data: secondItem }: IRowNode<ITodolistTemplate>
    ): number => {
      if (firstItem && secondItem) {
        return dateComparator(firstItem.template.updated_at, secondItem.template.updated_at)
      }
      if (firstItem) {
        return -1
      }
      return 1
    },
    field: 'template.updated_by',
    suppressHeaderMenuButton: true,
    valueGetter: ({ data }) => data?.template || undefined,
  }),
  actionsColDef(ActionsCellRenderer, {
    field: 'actions',
  }),
]

export default columns
